import { render, staticRenderFns } from "./Protections.vue?vue&type=template&id=74320f36&scoped=true&"
import script from "./Protections.vue?vue&type=script&lang=js&"
export * from "./Protections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74320f36",
  null
  
)

export default component.exports